/**
 * 일자 관련 함수 모음
 *
 * 개발자 : T/F팀
 * 개발년월 : 2022.11.
 */

export class DateUtil {

	/**
	YYYYMMDDHHMISS to Milliseconds
	 */
	static makeDate(hstime) {
		var s = hstime + "";
		var year = parseInt(s.substring(0, 4));
		var month = parseInt(s.substring(4, 6)) - 1;
		var day = parseInt(s.substring(6, 8));
		if (isNaN(day)) {
			s += '01';
			day = 1;
		}
		if (isNaN(month)) {
			s += '01';
			month = 1;
		}
		var hour = 0;
		var minute = 0;
		var second = 0;
		if (s.length >= 10) hour = parseInt(s.substring(8, 10));
		if (s.length >= 12) minute = parseInt(s.substring(10, 12));
		if (s.length >= 14) second = parseInt(s.substring(12, 14));

		const d = new Date(year, month, day, hour, minute, second, 0);

		return d;
	}

	static #makeHstime(value) {
		let ret = "";
		const str = value + "";
		for (const ch of str) {
			if (ch >= "0" && ch <= "9") {
				ret += ch;
			}
		}
		for (let i = ret.length; i < 14; i++) {
			ret += "0";
		}
		return ret;
	}

	static getDate(str) {
		const s = DateUtil.#makeHstime(str);

		var year = parseInt(s.substring(0, 4));
		var month = parseInt(s.substring(4, 6)) - 1;
		var day = parseInt(s.substring(6, 8));
		var hour = 0;
		var minute = 0;
		var second = 0;
		if (s.length >= 10) hour = parseInt(s.substring(8, 10));
		if (s.length >= 12) minute = parseInt(s.substring(10, 12));
		if (s.length >= 14) second = parseInt(s.substring(12, 14));

		const d = new Date(year, month, day, hour, minute, second, 0);

		return d;
	}

	static convert(hstime) {
		let s = hstime + "";
		if (s.length >= 8) {
			let ret = s.substring(0, 4) + "-" + s.substring(4, 6) + "-" + s.substring(6, 8);

			if (s.length == 14) {
				ret += " ";
				ret += s.substring(8, 10) + ":" + s.substring(10, 12) + ":" + s.substring(12, 14);
			}
			return ret;
		} else if (s.length < 4) {
			return "-";
		} else {
			return s;
		}
	}

	/**
	mstime : 추가할 시간(milliseconds 단위)
	 */
	static getDtm(mstime) {

		function addZero(i) {
			if (i < 10) { i = "0" + i }
			return i + "";
		}

		const d = new Date();

		if (mstime != undefined) {
			d.setTime(mstime);
		}

		let year = d.getFullYear();
		let month = d.getMonth() + 1;
		let day = d.getDate();
		let hour = d.getHours();
		let minutes = d.getMinutes();
		let seconds = d.getSeconds();

		return year.toString() + addZero(month) + addZero(day) + addZero(hour) + addZero(minutes) + addZero(seconds);
	}


	static getDdHh(mstime, delimiter = ' ') {

		function addZero(i) {
			if (i < 10) { i = "0" + i }
			return i;
		}

		const d = new Date();
		d.setTime(mstime);

		let day = d.getDate();
		let hour = d.getHours();

		return addZero(day) + delimiter + addZero(hour);
	}



	static getYmdAdd(mstime, separator = '') {

		function addZero(i) {
			if (i < 10) { i = "0" + i }
			return i;
		}

		const d = new Date();

		if (mstime != undefined) {
			d.setTime(d.getTime() + mstime);
		}


		let year = d.getFullYear();
		let month = d.getMonth() + 1;
		let day = d.getDate();

		return year + separator + addZero(month) + separator + addZero(day);
	}

	static makeYmd(hstime) {
		let s = hstime + "";
		let chars = s.split('');
		let ret = "";
		for (let ch of chars) {
			if (ch >= '0' && ch <= '9') ret += ch;
			if (ret.length == 8) break;
		}
		return ret;
	}


	static getYmd(mstime, separator = '') {

		function addZero(i) {
			if (i < 10) { i = "0" + i }
			return i;
		}

		const d = new Date();
		d.setTime(mstime);

		let year = d.getFullYear();
		let month = d.getMonth() + 1;
		let day = d.getDate();

		return year + separator + addZero(month) + separator + addZero(day);
	}
}

